import { apiClient } from '../apiClient';
import type { ApiResponse } from '../http/types';
import { SiteListItem } from '../siteManagement/siteManagement.types';

const base = '/api/SiteManagement';

export interface CreateSiteNoteRequest {
  Note: string;
}

export function listCommsSites(isOnline: boolean): Promise<ApiResponse<SiteListItem[]>> {
  const params = new URLSearchParams({
    isOnline: isOnline ? 'true' : 'false'
  });

  const url = `${base}/sites/communication-status?${params.toString()}`;
  return apiClient.get<SiteListItem[]>(url, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  });
}

export function listCommsSiteNotes(siteIdentifierRegistryId: number): Promise<ApiResponse<unknown>> {
  return apiClient.get<unknown>(
    `${base}/sites/${encodeURIComponent(siteIdentifierRegistryId)}/site-notes`
  );
}

export function createCommsSiteNote(
  siteIdentifierRegistryId: number,
  payload: CreateSiteNoteRequest
): Promise<ApiResponse<unknown>> {
  return apiClient.post<unknown>(
    `${base}/sites/${encodeURIComponent(siteIdentifierRegistryId)}/site-notes`,
    payload
  );
}

